import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import Alert from '../components/ui/Alert'
import Button from '../components/ui/Button'
import ar from '../locales/ar.json'

const t = ar.admin

export default function AdminLoginPage() {
  const { login }   = useAuth()
  const navigate    = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]     = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!username.trim() || !password) {
      setError('يرجى إدخال اسم المستخدم وكلمة المرور')
      return
    }
    setError('')
    setLoading(true)
    try {
      await login(username.trim(), password)
      navigate('/admin', { replace: true })
    } catch (err) {
      setError(err.message || 'فشل تسجيل الدخول')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-primary-700 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logos/logo_vertical.png" alt="" className="h-20 mx-auto mb-4" />
          <h1 className="text-white text-lg font-semibold">{t.loginTitle}</h1>
          <p className="text-primary-200 text-sm">{t.loginSubtitle}</p>
        </div>

        <div className="card">
          {error && <Alert type="error" message={error} className="mb-4" />}

          <form onSubmit={handleSubmit} noValidate className="space-y-4">
            <div>
              <label htmlFor="username" className="label-base">{t.username}</label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="input-base"
                autoComplete="username"
                dir="ltr"
                style={{ textAlign: 'right' }}
                required
              />
            </div>

            <div>
              <label htmlFor="password" className="label-base">{t.password}</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-base"
                autoComplete="current-password"
                dir="ltr"
                required
              />
            </div>

            <Button type="submit" variant="primary" className="w-full" loading={loading}>
              {t.login}
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}
